import { mapApiAddressToContactAddress } from "./mapApiAddressToContactAddress";
/**
 * Maps the BFF `ContactByIdModel` wire shape to the {@link ContactDetail}
 * domain model: parses date strings into `Date` instances and flattens the
 * address collection into the shared `Address` shape (with id) used by the
 * detail page.
 */
export function mapApiContactByIdToContactDetail(api) {
    return {
        id: api.id,
        externalId: api.externalId,
        salutation: api.salutation,
        firstName: api.firstName,
        lastName: api.lastName,
        birthDate: api.birthDate ? new Date(api.birthDate) : undefined,
        status: api.status,
        createdAt: new Date(api.createdAt),
        updatedAt: new Date(api.updatedAt),
        createdBy: api.createdByUser,
        updatedBy: api.updatedByUser,
        avatarUrl: api.avatarUrl,
        courtesy: api.courtesy,
        maidenName: api.maidenName,
        gender: api.gender,
        countryOfResidence: api.countryOfResidence,
        preferredLanguage: api.preferredLanguage,
        type: api.type,
        categories: api.categories ?? (api.category ? [api.category] : []),
        source: api.source ?? null,
        motivation: api.motivation ?? null,
        relationLevel: api.relationLevel ?? null,
        contactFrequency: api.contactFrequency ?? null,
        preferredChannel: api.preferredChannel ?? null,
        addresses: (api.addresses ?? []).map(mapApiAddressToContactAddress),
        communicationChannels: (api.communicationChannels ?? []).map((c) => ({
            id: c.id,
            type: c.type,
            value: c.value,
            isPrimary: c.isPrimary,
            usage: c.usage ?? null,
            linkedOrganisationName: c.linkedOrganisationName ?? null,
            subType: c.subType ?? null,
            isShared: c.isShared ?? false,
            sharedOwnerRole: c.sharedOwnerRole ?? null,
        })),
        identifiers: (api.identifiers ?? []).map((i) => ({
            id: i.id,
            type: i.type,
            value: i.value,
            label: i.label,
        })),
        socialProfiles: (api.socialProfiles ?? []).map((s) => ({
            id: s.id,
            networkId: s.socialNetwork.id,
            networkCode: s.socialNetwork.code,
            networkName: s.socialNetwork.name,
            iconClass: s.socialNetwork.iconClass,
            urlPrefix: s.socialNetwork.urlPrefix,
            value: s.value,
            label: s.label,
        })),
    };
}
